// src/pages/HotelDetail.js
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import hotelsData from '../data/hotels.json';
import '../styles/HotelDetail.css';
import ad1 from '../assets/ad4.png'; // advertisement banner

const imageMap = {
  '../assets/himalayanretreat.png': require('../assets/himalayanretreat.png'),
  '../assets/himalayanretreat1.png': require('../assets/himalayanretreat1.png'),
  '../assets/himalayanretreat2.png': require('../assets/himalayanretreat2.png'),
  '../assets/himalayanretreat3.png': require('../assets/himalayanretreat3.png'),
  '../assets/himalayanretreat4.png': require('../assets/himalayanretreat4.png'),
  '../assets/desertpearl.png': require('../assets/desertpearl.png'),
  '../assets/desertpearl1.png': require('../assets/desertpearl1.png'),
  '../assets/desertpearl2.png': require('../assets/desertpearl2.png'),
  '../assets/desertpearl3.png': require('../assets/desertpearl3.png'),
  '../assets/desertpearl4.png': require('../assets/desertpearl4.png'),
  '../assets/costalbliss.png': require('../assets/costalbliss.png'),
  '../assets/coastalbliss1.png': require('../assets/coastalbliss1.png'),
  '../assets/coastalbliss2.png': require('../assets/coastalbliss2.png'),
  '../assets/coastalbliss3.png': require('../assets/coastalbliss3.png'),
  '../assets/imperial.png': require('../assets/imperial.png'),
  '../assets/imperial1.png': require('../assets/imperial1.png'),
  '../assets/imperial2.png': require('../assets/imperial2.png'),
  '../assets/imperial3.png': require('../assets/imperial3.png'),
  '../assets/imperial4.png': require('../assets/imperial4.png'),
  '../assets/umaid.png': require('../assets/umaid.png'),
  '../assets/umaid1.png': require('../assets/umaid1.png'),
  '../assets/umaid2.png': require('../assets/umaid2.png'),
  '../assets/umaid3.png': require('../assets/umaid3.png'),
  '../assets/umaid4.png': require('../assets/umaid4.png'),
  '../assets/umaid5.png': require('../assets/umaid5.png'),
  '../assets/oberoi.png': require('../assets/oberoi.png'),
  '../assets/oberoi1.png': require('../assets/oberoi1.png'),
  '../assets/oberoi2.png': require('../assets/oberoi2.png'),
  '../assets/oberoi3.png': require('../assets/oberoi3.png'),
  '../assets/leelaudaipur.png': require('../assets/leelaudaipur.png'),
  '../assets/leela1.png': require('../assets/leela1.png'),
  '../assets/leela2.png': require('../assets/leela2.png'),
  '../assets/leela3.png': require('../assets/leela3.png'),
  '../assets/tajudaipur.png': require('../assets/tajudaipur.png'),
  '../assets/tajlake1.png': require('../assets/tajlake1.png'),
  '../assets/tajlake2.png': require('../assets/tajlake2.png'),
  '../assets/tajlake3.png': require('../assets/tajlake3.png'),
  '../assets/tajlake4.png': require('../assets/tajlake4.png'),
  '../assets/taj.png': require('../assets/taj.png'),
  '../assets/exotica1.png': require('../assets/exotica1.png'),
  '../assets/exotic2.png': require('../assets/exotic2.png'),
  '../assets/exotica3.png': require('../assets/exotica3.png'),
  '../assets/wildflower.png': require('../assets/wildflower.png'),
  '../assets/wildflower1.png': require('../assets/wildflower1.png'),
  '../assets/wildflower2.png': require('../assets/wildflower2.png'),
  '../assets/wildflower3.png': require('../assets/wildflower3.png'),
  '../assets/streggis.png': require('../assets/streggis.png'),
  '../assets/regis1.png': require('../assets/regis1.png'),
  '../assets/regis2.png': require('../assets/regis2.png'),
  '../assets/regis3.png': require('../assets/regis3.png'),
  '../assets/ananta.png': require('../assets/ananta.png'),
  '../assets/ananta1.png': require('../assets/ananta1.png'),
  '../assets/ananta2.png': require('../assets/ananta2.png'),
  '../assets/ananta3.png': require('../assets/ananta3.png'),
  '../assets/welcomhotel.png': require('../assets/welcomhotel.png'),
  '../assets/welcom1.png': require('../assets/welcom1.png'),
  '../assets/welcom2.png': require('../assets/welcom2.png'),
  '../assets/welcom3.png': require('../assets/welcom3.png'),
  '../assets/aahana.png': require('../assets/aahana.png'),
  '../assets/aahana1.png': require('../assets/aahana1.png'),
  '../assets/aahana2.png': require('../assets/aahana2.png'),
  '../assets/aahana3.png': require('../assets/aahana3.png'),
  '../assets/tajtheog.png': require('../assets/tajtheog.png'),
  '../assets/tajtheog1.png': require('../assets/tajtheog1.png'),
  '../assets/tajtheog2.png': require('../assets/tajtheog2.png'),
  '../assets/tajtheog3.png': require('../assets/tajtheog3.png'),
  '../assets/w.png': require('../assets/w.png'),
  '../assets/w1.png': require('../assets/w1.png'),
  '../assets/w2.png': require('../assets/w2.png'),
  '../assets/w3.png': require('../assets/w3.png'),
  '../assets/lalit.png': require('../assets/lalit.png'),
  '../assets/lalit1.png': require('../assets/lalit1.png'),
  '../assets/lalit2.png': require('../assets/lalit2.png'),
  '../assets/lalit3.png': require('../assets/lalit3.png'),
  '../assets/lalit4.png': require('../assets/lalit4.png'),
  '../assets/nainiretreat.png': require('../assets/nainiretreat.png'),
  '../assets/naini1.png': require('../assets/naini1.png'),
  '../assets/naini2.png': require('../assets/naini2.png'),
  '../assets/naini3.png': require('../assets/naini3.png'),
  '../assets/naini4.png': require('../assets/naini4.png'),
  '../assets/neemrana.png': require('../assets/neemrana.png'),
  '../assets/neemrana1.png': require('../assets/neemrana1.png'),
  '../assets/neemrana2.png': require('../assets/neemrana2.png'),
  '../assets/neemrana3.png': require('../assets/neemrana3.png')
};

const HotelDetail = () => {
  const { id } = useParams();
  const hotel = hotelsData.find(h => h.id === parseInt(id));

  if (!hotel) return <div>Hotel not found</div>;

  return (
<div className="hotel-detail">
  <Link to="/hotels" className="back-link">← Back to Hotels</Link>
  <h1>{hotel.name}</h1>
  <p>{hotel.city}, {hotel.state}</p>

  <div className="hotel-main-image-container">
    <img src={imageMap[hotel.image]} alt={hotel.name} className="hotel-main-image" />
  </div>

  <p className="description">{hotel.description}</p>

  {/* Two-column layout */}
  <div className="hotel-info-section">
    <div className="left-section">
      <h3>Room Pricing</h3>
      {hotel.roomPricing && typeof hotel.roomPricing === 'object' ? (
        <ul>
          {Object.entries(hotel.roomPricing).map(([room, price], index) => (
            <li key={index}>
              {room}: ₹{price.toLocaleString()}
            </li>
          ))}
        </ul>
      ) : (
        <p>No room pricing information available.</p>
      )}

      <h3>Amenities</h3>
      <ul>
        {hotel.amenities.map((a, i) => <li key={i}>{a}</li>)}
      </ul>

      <h3>Policies</h3>
      <ul>
        {hotel.policies?.checkIn && <li><strong>Check-In:</strong> {hotel.policies.checkIn}</li>}
        {hotel.policies?.checkOut && <li><strong>Check-Out:</strong> {hotel.policies.checkOut}</li>}
        {hotel.policies?.childrenPolicy && <li><strong>Children Policy:</strong> {hotel.policies.childrenPolicy}</li>}
        {hotel.policies?.petsAllowed && <li><strong>Pets Allowed:</strong> {hotel.policies.petsAllowed}</li>}
        {hotel.policies?.paymentMethods && Array.isArray(hotel.policies.paymentMethods) && (
          <li>
            <strong>Payment Methods:</strong>
            <ul>
              {hotel.policies.paymentMethods.map((method, i) => (
                <li key={i}>{method}</li>
              ))}
            </ul>
          </li>
        )}
      </ul>
    </div>

    <div className="right-section">
      {hotel.extraImages && Array.isArray(hotel.extraImages) && (
        <div className="extra-images">
          {hotel.extraImages.map((img, idx) => (
            <img src={imageMap[img]} alt={`extra-${idx}`} key={idx} />
          ))}
        </div>
      )}
            <div className="ads-section">
              <img src={ad1} alt="Ad" className="ads-banner" />
            </div>
    </div>
  </div>
</div>
  );
};

export default HotelDetail;